export class CustomerGridViewItem {
    id?: string;
    name?: string;
    constructor(customerGridViewItem?: CustomerGridViewItem) {
        this.id = customerGridViewItem?.id;
        this.name = customerGridViewItem?.name;       
    }
}
